import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

const DASH = {
  sender: "/sender", lorry_owner: "/owner", driver: "/driver", admin: "/admin",
};

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { refreshUser } = useAuth();
  const done = useRef(false);

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    const roleHint = localStorage.getItem("pending_role") || "sender";
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, role_hint: roleHint });
        if (data.token) localStorage.setItem("ll_token", data.token);
        localStorage.removeItem("pending_role");
        toast.success(`Welcome, ${data.user.name}`);
        await refreshUser?.();
        window.history.replaceState({}, "", "/");
        nav(DASH[data.user.role] || "/", { replace: true });
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail) || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav, refreshUser]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-flex mb-6"><Logo /></div>
        <div className="overline text-[#FF5A00]">SIGNING YOU IN</div>
        <div className="mt-4 text-zinc-400 text-sm">Verifying your Google session with NorthLine…</div>
      </div>
    </div>
  );
}
